import React from "react";
import MainRouter from "./components/mainRouter";

const App = () => {
  return <MainRouter />;
};

export default App;
